module.exports = __webpack_public_path__ + "static/img/empty_blue.02bf6eda.png";